export const GOOGLE_MAPS_SCRIPT_ID = "google-maps-script";
export const GOOGLE_MAPS_VERSION = "weekly";
export const GOOGLE_MAPS_JS_API_LIBRARIES = Object.freeze([
  "drawing",
  "geometry",
  "places",
]);

export const getGoogleMapsBrowserApiKey = () =>
  process.env.REACT_APP_GOOGLE_API_KEY || "";

export const getGoogleRoutesApiKey = () =>
  process.env.REACT_APP_GOOGLE_ROUTES_API_KEY || "";

